import request from "@/utils/http";

export const GET_USER_LIST = "/sys_user/query_user_list.do";

export const login = async (data) => {
  return request({
    method: "POST",
    url: "/auth/username_pwd_login.do",
    data,
  });
};

export const getLoginInfo = async () => {
  return request({
    method: "GET",
    url: "/user_info/get_login_info.do",
  });
};

export const getPublicKey = async (data) => {
  return request({
    method: "GET",
    url: "/auth/rsa/public_key.do",
    data,
  });
};

export const getUsers = async (params) => {
  return request({
    method: "GET",
    url: "/sys_user/query_user_list.do",
    params,
  });
};

export const addUser = async (data) => {
  return request({
    method: "POST",
    url: "/sys_user/add_user.do",
    data,
  });
};

export const editUser = async (data) => {
  return request({
    method: "put",
    url: "/sys_user/update_user.do",
    data,
  });
};

export const deleteUser = async (data) => {
  return request({
    method: "post",
    url: "/sys_user/delete_user.do",
    data,
  });
};

export const queryUser = async (id) => {
  return request({
    method: "get",
    url: `/sys_user/query_user.do?id=${id}`,
  });
};

export const modifyPsw = async (data) => {
  return request({
    method: "post",
    url:'/user_info/modify_user_pwd.do',
    data
  })
}
